<mat-tab-group class="with-title-headers" mat-align-tabs="end">
  <mat-tab *ngFor="let tab of field.fieldGroup; let i = index; let last = last">
    <ng-template mat-tab-label>
      <div class="d-flex w-100 justify-content-between align-items-center">
        <span class="label-tab">{{ (tab.templateOptions?.label | apmTranslate) || '' }}</span>
        <div class="icon-error">
          <apm-icon *ngIf="!isValid(tab?.fieldGroup)" size="xs" icon="aa_alert_filter"> </apm-icon>
        </div>
      </div>
    </ng-template>
    <ng-template matTabContent>
      <div class="tab-content">
        <formly-field [field]="tab"></formly-field>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
